import { useEffect } from "react";
import { Link } from "react-router-dom";
import { BUSINESS } from "@/lib/business";

const Block = ({ title, children }) => (
  <article className="space-y-3 leading-relaxed">
    <h2 className="dp text-3xl text-plate">{title}</h2>
    {children}
  </article>
);

export default function Impressum() {
  useEffect(() => { window.scrollTo(0, 0); document.title = "Impressum – PC Zulassungsdienst"; }, []);
  return (
    <section className="shade-paper text-ink py-20 md:py-28" data-testid="impressum-page">
      <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-[220px_1fr] gap-12">
        <aside className="lb text-inkmuted border-l-2 border-plate pl-4 h-fit">
          <p>Rechtliches</p>
          <Link to="/" className="mt-2 block hover:text-plate transition-colors" data-testid="impressum-back-link">← Zur Startseite</Link>
        </aside>
        <div className="min-w-0 max-w-3xl space-y-12">
          <h1 className="dp pc-h2">Impressum</h1>
          <Block title="Angaben gemäß § 5 DDG">
            <p className="whitespace-pre-line">{`PC Zulassungsdienst\nInhaber: ${BUSINESS.owner}\n${BUSINESS.street}\n${BUSINESS.city}\nDeutschland`}</p>
          </Block>
          <Block title="Kontakt">
            <p>Telefon: <a href={`tel:${BUSINESS.phoneTel}`} className="underline hover:text-plate">{BUSINESS.phoneDisplay}</a></p>
            <p>E-Mail: <a href={`mailto:${BUSINESS.email}`} className="underline hover:text-plate">{BUSINESS.email}</a></p>
            <p>Website: www.pc-zulassungsdienst.de</p>
          </Block>
          <Block title="Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV">
            <p className="whitespace-pre-line">{`${BUSINESS.owner}\n${BUSINESS.street}\n${BUSINESS.city}`}</p>
          </Block>
          <Block title="Verbraucherstreitbeilegung">
            <p>Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.</p>
          </Block>
          <Block title="Haftung für Inhalte">
            <p>Als Diensteanbieter sind wir für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Wir sind jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.</p>
          </Block>
          <Block title="Haftung für Links">
            <p>Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.</p>
          </Block>
          <Block title="Urheberrecht">
            <p>Die durch den Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.</p>
          </Block>
        </div>
      </div>
    </section>
  );
}
